<template>
  <div class="form-group">
    <label for="address">
      {{ label }}
    </label>
    <input
      id="autocomplete"
      :value="addressFormatted"
      class="form-control"
      :class="customValidation"
      placeholder="15 rue Poissonière, 75002 Paris, FRANCE"
      type="text"
      aria-autocomplete="none"
      autocomplete="off"
      @input.once="appendCustom"
      @focus="focusPlace"
      @blur="blurPlace"
    >
    <transition
      tag="div"
      @enter="tf_slideDown"
      @leave="tf_slideUp"
    >
      <div
        v-if="isAddressComplete === false"
        class="invalid-feedback"
      >
        {{ errorMessage }}
      </div>
    </transition>
    <transition
      tag="div"
      @enter="tf_slideDown"
      @leave="tf_slideUp"
    >
      <div
        v-if="customError"
        class="invalid-feedback"
      >
        {{ customErrorMessage }}
      </div>
    </transition>
    <transition
      tag="div"
      @enter="tf_slideDown"
      @leave="tf_slideUp"
    >
      <v-address
        v-if="showAddressFiller"
        class="mt-3 mb-5"
        :action-module="actionModule"
        :action-name="actionName"
        :path="path"
      />
    </transition>
  </div>
</template>
<script>
import { get } from 'lodash-es';
import { mapGetters } from 'vuex';
import maps from '@/services/vendors/maps';

import { transform } from '@/mixins';
import Address from '@/components/common/input/Address.vue';
import { validateAddress } from '@/utils/validators';

export default {
  name: 'InputPlace',
  components: {
    'v-address': Address,
  },
  mixins: [transform],
  props: {
    label: {
      type: String,
      required: false,
      default: () => '',
    },
    actionModule: {
      type: String,
      default: 'company',
    },
    actionName: {
      type: String,
      default: 'setValueWithPath',
    },
    path: {
      type: String,
      required: false,
      default: () => '',
    },
    errorMessage: {
      type: String,
      required: false,
      default: 'Error message',
    },
  },
  data() {
    return {
      getPlace: () => {},
      showAddressFiller: false,
      customError: false,
      customErrorMessage: 'Veuillez saisir manuellement votre adresse',
    };
  },
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
    address() {
      return get(this, 'contract.risk.local.address');
    },
    addressFormatted() {
      if (this.address) {
        const address = Object.values(this.address);
        if (address.length) {
          return address.join(' ').trim();
        }
      }
      return '';
    },
    isAddressComplete() {
      return (validateAddress(this.address));
    },
    customValidation() {
      return this.isAddressComplete === false ? 'is-invalid' : '';
    },
    pacContainer() {
      if (document.getElementsByClassName('pac-container').length) {
        return document.getElementsByClassName('pac-container')[0];
      }
      return [];
    },
  },
  watch: {
    isAddressComplete: {
      handler(value) {
        if (value) {
          this.customError = false;
        }
      },
    },
  },
  mounted() {
    this.getPlace = maps('autocomplete', this.update, this.setError);
  },
  beforeDestroy() {
    const pac = document.getElementsByClassName('pac-container');
    if (pac.length > 0) {
      for (let i = 0; i < pac.length; i += 1) {
        const element = pac[i];
        element.remove();
      }
    }
  },
  methods: {
    update(address) {
      if (this.path !== '') {
        this.$store.dispatch(`${this.actionModule}/${this.actionName}`,
          { value: { ...address }, path: this.path });
      } else {
        this.$store.dispatch(`${this.actionModule}/${this.actionName}`, { ...address });
      }
    },
    setError() {
      this.customError = true;
      this.showAddressFiller = true;
    },
    focusPlace() {
      this.scrollBot();
      if (import.meta.env.NODE_ENV === 'local') {
        const elems = document.getElementsByClassName('pac-container');
        if (elems) {
          for (let i = 0; i < elems.length; i += 1) {
            const element = elems[i];
            element.classList.add('d-flex');
          }
        }
      }
    },
    blurPlace() {
      if (import.meta.env.NODE_ENV === 'local') {
        const elems = document.getElementsByClassName('pac-container');
        if (elems) {
          for (let i = 0; i < elems.length; i += 1) {
            const element = elems[i];
            element.classList.remove('d-flex');
          }
        }
      }
    },
    scrollBot() {
      const el = document.getElementById('autocomplete');
      const container = document.getElementById('modalApp');
      this.tf_scrollTo(el, container, () => {}, this.showAddressFiller ? -200 : 0);
    },
    appendCustom() {
      const elems = document.getElementsByClassName('pac-container');
      const container = document.createElement('div');
      const insideSpan = document.createElement('span');
      container.classList.add('pac-item');
      container.classList.add('order-2');
      insideSpan.classList.add('pac-item-query');
      insideSpan.classList.add('font-weight-bold');
      insideSpan.innerText = ('Je ne trouve pas mon adresse');
      container.appendChild(insideSpan);
      container.addEventListener('mousedown', () => {
        this.showAddressFiller = true;
      });
      if (elems) {
        for (let i = 0; i < elems.length; i += 1) {
          const element = elems[i];
          element.appendChild(container);
        }
      }
    },
  },
};
</script>
<style>
input::placeholder {
  color:rgb(175, 175, 175);
}
.pac-logo:after {
  order:3;
}
.pac-container {
  margin-top: 1em;
  z-index: 1051 !important;
  flex-direction: column;
  order: 1;
  width: 100%;
  padding: 1rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 2px solid #ced4da;
  border-radius: 8px;
  box-shadow: none;
}
.pac-item {
  border:0;
  padding: 1em 0;
}
</style>
